import { z } from "@/zod";
import { assignments } from "./assignments";

export const departmentBasedAssignments = assignments.extend({
  payroll_department_id: z.string().length(26),
  payroll_department_name: z.string(),
});

export const readDepartmentBasedAssignments =
  departmentBasedAssignments.readonly();

export const writeDepartmentBasedAssignments = departmentBasedAssignments
  .omit({
    id: true,
    payroll_department_name: true,
    store_name: true,
    contractor_name: true,
    status: true,
  })
  .extend({
    end_date: z.string().date().optional().catch(undefined),
  });
